import type { CustomRoleTaxonomySelection } from '@revelio/data-access';

import { defineSingleValueFilter } from '../engine/descriptor';
import type { FilterDefinition } from '../engine/types';
import { FilterId, FilterType, type SingleValueFilter } from '../types/filters';

export const roleTaxonomyDescriptor =
  defineSingleValueFilter<CustomRoleTaxonomySelection>()({
    definition: {
      id: FilterId.ROLE_TAXONOMY,
      name: 'Role Taxonomy',
      value: { default: true },
      type: FilterType.VALUE,
      isVisible: false,
      isActive: true,
    },
  });

export const roleTaxonomyDefinition: FilterDefinition<
  SingleValueFilter<CustomRoleTaxonomySelection>
> = roleTaxonomyDescriptor.definition;
